import React from 'react';
import { Link } from 'react-router-dom';
import {
  Container, Typography, Grid, Card, CardContent, CardActions, Button
} from '@mui/material';
import DevicesIcon from '@mui/icons-material/Devices';
import GroupIcon from '@mui/icons-material/Group';
import SearchIcon from '@mui/icons-material/Search';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: '#f9f9fb',
  borderRadius: '16px',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 8px 20px rgba(0,0,0,0.15)'
  }
}));

const iconStyle = {
  fontSize: 40,
  color: '#1565c0', // your app's primary color
};

const AdminDashboard = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: '#1565c0' }}>
        Admin Dashboard
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} sm={6} md={3}>
          <StyledCard>
            <CardContent>
              <DevicesIcon style={iconStyle} />
              <Typography variant="h6" mt={2}>Gadget Management</Typography>
              <Typography variant="body2" color="textSecondary">
                View and manage all registered gadgets.
              </Typography>
            </CardContent>
            <CardActions>
              <Button fullWidth variant="contained" color="primary" component={Link} to="/admin/gadgets">
                View Gadgets
              </Button>
            </CardActions>
          </StyledCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <StyledCard>
            <CardContent>
              <GroupIcon style={iconStyle} />
              <Typography variant="h6" mt={2}>User Management</Typography>
              <Typography variant="body2" color="textSecondary">
                Manage all user accounts and roles.
              </Typography>
            </CardContent>
            <CardActions>
              <Button fullWidth variant="contained" color="primary" component={Link} to="/admin/users">
                Manage Users
              </Button>
            </CardActions>
          </StyledCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <StyledCard>
            <CardContent>
              <SearchIcon style={iconStyle} />
              <Typography variant="h6" mt={2}>Search Logs</Typography>
              <Typography variant="body2" color="textSecondary">
                View search history and logs with IP.
              </Typography>
            </CardContent>
            <CardActions>
              <Button fullWidth variant="contained" color="primary" component={Link} to="/admin/search-logs">
                View Logs
              </Button>
            </CardActions>
          </StyledCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <StyledCard>
            <CardContent>
              <MonetizationOnIcon style={iconStyle} />
              <Typography variant="h6" mt={2}>Subscriptions</Typography>
              <Typography variant="body2" color="textSecondary">
                Handle subscription plans and statuses.
              </Typography>
            </CardContent>
            <CardActions>
              <Button fullWidth variant="contained" color="primary" component={Link} to="/admin/subscriptions">
                Manage Subscriptions
              </Button>
            </CardActions>
          </StyledCard>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AdminDashboard;
